var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.getUrl()}},[_c('i-avatar',{attrs:{"member":_vm.member,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }